export default {
    TOGGLE_PASSWORD_RESET_MODAL: 'TOGGLE_PASSWORD_RESET_MODAL'
}